/*
 * The roles shown under a person's name in the sidebar.
 *
 * The block used to render exactly two hardcoded badges - Admin and Experimenter - from before the
 * app had seven roles. Everything else was invisible there, so a producer who had been granted the
 * role in Settings saw no sign of it on their own profile and reasonably concluded the grant had
 * failed. (It hadn't: the role was in the token all along.)
 *
 * `sandbox` is deliberately not a badge. It is the company, not a role, and it is on every account
 * in the pool - a badge that is always there says nothing. #671 step 6 makes that explicit for the
 * other companies too, and the ordering below is the order they should appear in.
 */
const BADGES = [
  { group: 'admin', label: 'Admin' },
  { group: 'producer', label: 'Producer' },
  { group: 'sales', label: 'Sales' },
  { group: 'commercial', label: 'Commercial' },
  { group: 'experimental', label: 'Experimenter' },
  { group: 'testonly', label: 'Test only' },
]

// Roles we never show: the company, and anything the app does not know about.
const HIDDEN = ['sandbox']

const roleBadges = groups => {
  const held = (groups || []).map(group => String(group).toLowerCase())

  return BADGES.filter(badge => held.includes(badge.group)).map(badge => badge.label)
}

export { roleBadges, BADGES, HIDDEN }
